var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackToTop = function SvgBackToTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 12h2.7v13.5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V12h2.7c.7 0 1-.8.5-1.3l-4.2-4.2a.7.7 0 0 0-1 0l-4.2 4.2a.7.7 0 0 0 .5 1.3zM0 1.5C0 2.3.7 3 1.5 3h21c.8 0 1.5-.7 1.5-1.5S23.3 0 22.5 0h-21C.7 0 0 .7 0 1.5z"
  })));
};
export default SvgBackToTop;